import { useState } from "react";

const InstructorBio = () => {
	const [showMore, setShowMore] = useState(false);

	return (
		<div className="instructor-container">
			<p className="instructor-bio">
				Hi, I'm Soham! I'm a full-stack web developer and product designer with
				a passion for building beautiful web interfaces from scratch.
			</p>

			<p className="instructor-bio">
				I've been building websites and apps since 2020 and also have a diploma
				in Computer Engineering.
			</p>

			<p className="instructor-bio">
				I discovered my passion for teaching and helping others by sharing
				everything I knew during college. This passion led me to founding
				SimplyWebDev, where I now have the privilege of sharing my knowledge and
				skills with others.
			</p>

			{showMore && (
				<>
					<p className="instructor-bio">
						What learners love the most about me is the fact that I take the
						time to explain every single concept in a way that everyone can
						easily understand.
					</p>

					<p className="instructor-bio">
						<strong>
							Whether you want to build awesome websites with modern HTML and
							CSS,
						</strong>
						<br />
						<strong>kick start your JavaScript developer journey, </strong>
						<strong>
							<br />
							or design stunning web interfaces apart from coding{" "}
						</strong>
						<br />— my courses are designed for you.
					</p>

					<p className="instructor-bio">
						Don’t waste your time with random tutorials or incomplete YouTube
						videos. All my courses are easy-to-follow, beginner friendly, and
						built to take your skills to the next level.
					</p>

					<p className="instructor-bio">
						But don’t just take my word for it — see for yourself. Enroll in one
						of my courses and join me on a beautiful journey of design and
						development.
					</p>
				</>
			)}

			<button
				className="show-more-btn"
				onClick={() => setShowMore((prev) => !prev)}
			>
				{showMore ? "Show less" : "Show more"}
			</button>
		</div>
	);
};

export default InstructorBio;
